import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../hooks/usePageTitle';
import useCanonicalTag from '../hooks/useCanonicalTag';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/fonts.css';
import '../styles/news_page.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Ranking from '../components/Ranking';
import TopStreams from '../components/TopStreams';
import UpcomingEvents from '../components/UpcomingEvents';

function NewsDetail() {
  const { t } = useTranslation();
  usePageTitle('News');
  useCanonicalTag();
  useMetaTags({
    title: 'News | Celeritas',
    description: 'Latest news and updates about iRacing leagues and championships on Celeritas',
    url: 'https://celeritas.live/news'
  });

  return (
    <div className="NewsDetailPage">
      <Header />

      <main>
        <section id="hero-banner">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">{t('home.hero_title')}</h1>
              <p className="hero-sub">{t('home.hero_subtitle')}</p>
            </div>
            <div className="hero-actions">
              <Link to="/add-league" className="hero-btn-primary">{t('common.addMyLeague')}</Link>
              <Link to="/leagues" className="hero-btn-secondary">{t('common.viewLeagues')}</Link>
            </div>
          </div>
        </section>

        <div className="content-grid">
          <aside className="left-col">
            <Ranking />
            <TopStreams />
          </aside>

          <section className="center-col news-article">
            <nav className="breadcrumb">
              <Link to="/">{t('common.home')}</Link> &gt; <Link to="/news">{t('nav.news')}</Link> &gt; <span>iRacing</span>
            </nav>

            <article className="full-article">
              <header className="article-header">
                <h1>Temporada 1 de 2026 do iRacing: O guia completo de novidades</h1>
                <div className="article-meta">
                  <span className="author">{t('news.by')} <strong>Admin</strong></span>
                  <span className="date">{t('news.publishedAt')} 24 Jan, 2026 - 09:40</span>
                  <span className="comment-count">💬 14 {t('news.comments')}</span>
                </div>
              </header>

              <div className="featured-image">
                <img src="banner-iracing.jpg" alt="Destaque Temporada 1" />
              </div>

              <div className="article-body">
                <p>A nova temporada do iRacing chegou com mudanças significativas no modelo de pneus e três novos circuitos icônicos...</p>
                <h3>Novos Carros GT3</h3>
                <p>Os novos modelos trazem uma física refinada, especialmente na resposta do Force Feedback em zebras altas...</p>
                <div className="article-quote">
                  "Essa atualização é o maior salto em simulação que tivemos nos últimos 2 anos." - Diretor Técnico do iRacing.
                </div>
                <p>Confira abaixo a lista completa de mudanças no patch note oficial...</p>
              </div>

              <div className="article-tags">
                <span className="tag">#iRacing</span>
                <span className="tag">#GT3</span>
                <span className="tag">#Atualização</span>
              </div>
            </article>

            <section className="comments-section">
              <div className="box-header"><h3>{t('news.comments')}</h3></div>
              <div className="comment-input">
                <textarea placeholder={t('news.commentPlaceholder')}></textarea>
                <button className="btn-comment">{t('common.send')}</button>
              </div>
              <div className="comments-list">
                <div className="comment-item">
                  <div className="comment-user">Max_Fan_33</div>
                  <div className="comment-text">Espero que corrijam o problema do som no novo motor GT3!</div>
                  <div className="comment-footer"><span>{t('news.agoHour')}</span> | <a href="#">{t('news.reply')}</a></div>
                </div>
              </div>
            </section>
          </section>

          <aside className="right-col">
            <section className="course-banner">...</section>
            <UpcomingEvents />
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default NewsDetail;
